import {
  getRequestWithToken,
  putRequestWithToken,
  putRequestMultipart,
} from '../helpers/request';

export const getProfile = (filter) => {
  const apiUrl = `admins/profile`;
  return getRequestWithToken(apiUrl);
};

export const updateProfile = (params) => {
  const apiUrl = 'tenants/profile';
  return putRequestWithToken(apiUrl, params);
};

export const updateLogo = (file) => {
  const apiUrl = 'tenants/profile/logo';
  return putRequestMultipart(apiUrl, file);
};

export const deleteLogo = (file) => {
  const apiUrl = 'tenants/profile';
  return putRequestWithToken(apiUrl, file);
};
// export const updateProduct = (id, params) => {
//   const apiUrl = `products/${id}`;
//   return putRequestWithToken(apiUrl, params);
// };
